import React, { useState } from 'react'
import loginBackground from '@/assets/images/login_background.png'
import valiantlytixLogo from '@/assets/images/darkLogo.png'
import { Button, Form, Input } from 'antd'
import { useNavigate } from 'react-router'
import logo from '@/assets/images/vantageAI.png'
import axios from 'axios';
import { toast } from 'sonner'
import './login/NewLoginPage.css';
import AuthErrorModal from '@/components/AuthErrorModal';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { VITE_APP_URL: URL } = import.meta.env;

  const [email, setEmail] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorTitle, setErrorTitle] = useState<string>("Reset Password Error");

  const handleResetPassword = async () => {
    try {
      if (!email) {
        setErrorTitle("Missing Email");
        setErrorMessage("Please enter your registered email address.");
        return;
      }
      setButtonLoading(true);
      const response = await axios.post(`${URL}/api/users/forgot-password`, {
        "email": email
      })

      setButtonLoading(false);
      if (response?.data?.status === false || response?.data?.success === false) {
          setErrorTitle("Reset Failed");
          setErrorMessage(response?.data?.message || "Failed to send verification email. Please try again.");
      } else {
          toast.info(response?.data?.message || "Verification email is sent to your inbox");
      }


    } catch (err: any) {
      console.log(err);
      setErrorTitle("Reset Failed");
      if (err?.response?.data?.message || err?.response?.data?.error) {
        setErrorMessage(err.response.data.message || err.response.data.error);
      } else {
        setErrorMessage("An error occurred while attempting to send the reset link. Please try again.");
      }
    } finally {
      setButtonLoading(false);
    }
  }

  return (
    <div className='flex w-full h-screen bg-[#F8F9FA] font-sans'>
      {/* Left side: Form Panel */}
      <div className='w-full lg:w-1/2 h-full flex flex-col items-center relative px-4 sm:px-8 overflow-y-auto'>
        
        <div className='w-full max-w-[440px] flex flex-col items-center my-auto py-8'>
          {/* Logo at Top */}
          <div className='w-full flex justify-center mb-8'>
            <img src={logo} alt="Vantage AI Logo" className='w-[160px] md:w-[200px] h-auto object-contain' />
          </div>

          {/* Form Container */}
          <div className='w-full bg-white px-6 sm:px-8 py-8 sm:py-10 rounded-2xl shadow-sm border border-gray-100 flex flex-col'>
            <div className='flex flex-col gap-2 mb-6'>
              <div className='flex items-center gap-3'>
                <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.56888 17.85C1.13546 17.85 0.765625 17.6958 0.459375 17.3873C0.153125 17.0789 0 16.7081 0 16.275V7.875C0 7.44187 0.154219 7.07109 0.462656 6.76266C0.771094 6.45422 1.14188 6.3 1.575 6.3H2.1V4.2C2.1 3.038 2.51001 2.0475 3.33003 1.2285C4.14991 0.409499 5.14157 0 6.30503 0C7.46834 0 8.45833 0.409499 9.275 1.2285C10.0917 2.0475 10.5 3.038 10.5 4.2V6.3H11.025C11.4581 6.3 11.8289 6.45422 12.1373 6.76266C12.4458 7.07109 12.6 7.44187 12.6 7.875V16.275C12.6 16.7081 12.4457 17.0789 12.1371 17.3873C11.8285 17.6958 11.4575 17.85 11.0241 17.85H1.56888ZM1.575 16.275H11.025V7.875H1.575V16.275ZM6.30459 13.65C6.73903 13.65 7.10938 13.4953 7.41563 13.186C7.72188 12.8767 7.875 12.5048 7.875 12.0704C7.875 11.636 7.72034 11.2656 7.41103 10.9594C7.10172 10.6531 6.72984 10.5 6.29541 10.5C5.86097 10.5 5.49063 10.6547 5.18438 10.964C4.87813 11.2733 4.725 11.6452 4.725 12.0796C4.725 12.514 4.87966 12.8844 5.18897 13.1906C5.49828 13.4969 5.87016 13.65 6.30459 13.65ZM3.675 6.3H8.925V4.2C8.925 3.47083 8.66979 2.85104 8.15938 2.34063C7.64896 1.83021 7.02917 1.575 6.3 1.575C5.57083 1.575 4.95104 1.83021 4.44063 2.34063C3.93021 2.85104 3.675 3.47083 3.675 4.2V6.3Z" fill="#A51C1C"/>
</svg>

                <span className='text-xl md:text-2xl font-semibold tracking-[0.2px] text-gray-900'>Forgot Password</span>
              </div>
              <span className='text-gray-500 text-sm'>Please fill the below details</span>
            </div>

            <div className='flex flex-col gap-y-4'>
              <Form.Item label={<span className='text-sm font-medium text-gray-700 mb-1 block'>Email</span>} className='mb-0' layout='vertical'>
                <Input
                  size="large"
                  style={{ backgroundColor: "#F8F9FA", borderColor: "#E5E7EB", height: 48 }}
                  placeholder='example@gmail.com'
                  prefix={<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.7 5.7C4.90833 5.7 4.23542 5.42292 3.68125 4.86875C3.12708 4.31458 2.85 3.64167 2.85 2.85C2.85 2.05833 3.12708 1.38542 3.68125 0.83125C4.23542 0.277083 4.90833 0 5.7 0C6.49167 0 7.16458 0.277083 7.71875 0.83125C8.27292 1.38542 8.55 2.05833 8.55 2.85C8.55 3.64167 8.27292 4.31458 7.71875 4.86875C7.16458 5.42292 6.49167 5.7 5.7 5.7ZM0 11.4V9.5C0 9.19653 0.0824653 8.90955 0.247396 8.63906C0.412326 8.36858 0.639931 8.14097 0.930208 7.95625C1.6559 7.53403 2.42309 7.21076 3.23178 6.98646C4.04047 6.76215 4.86182 6.65 5.69584 6.65C6.52986 6.65 7.3526 6.76215 8.16406 6.98646C8.97552 7.21076 9.7441 7.53403 10.4698 7.95625C10.7601 8.12778 10.9877 8.35208 11.1526 8.62917C11.3175 8.90625 11.4 9.19653 11.4 9.5V11.4H0ZM1.425 9.975H9.975V9.5C9.975 9.43165 9.95501 9.36957 9.91503 9.31376C9.87518 9.25782 9.8226 9.21434 9.75729 9.18333C9.15035 8.81389 8.50382 8.53681 7.81771 8.35208C7.1316 8.16736 6.42569 8.075 5.7 8.075C4.97431 8.075 4.2684 8.16736 3.58229 8.35208C2.89618 8.53681 2.24965 8.81389 1.64271 9.18333C1.57674 9.23611 1.52396 9.28704 1.48438 9.33613C1.44479 9.38534 1.425 9.43997 1.425 9.5V9.975ZM5.70416 4.275C6.09722 4.275 6.43229 4.13507 6.70937 3.85522C6.98646 3.57536 7.125 3.23891 7.125 2.84584C7.125 2.45278 6.98507 2.11771 6.70522 1.84062C6.42536 1.56354 6.08891 1.425 5.69584 1.425C5.30278 1.425 4.96771 1.56493 4.69062 1.84478C4.41354 2.12464 4.275 2.46109 4.275 2.85416C4.275 3.24722 4.41493 3.58229 4.69478 3.85938C4.97464 4.13646 5.31109 4.275 5.70416 4.275Z" fill="#9AA1AD"/>
</svg>
}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="light-input rounded-lg hover:border-gray-300 focus:border-[#A91D22]"
                />
              </Form.Item>

              <Button type='primary' size='large' onClick={handleResetPassword} loading={buttonLoading} className='w-full h-12 mt-4 text-base font-medium !bg-[#A91D22] hover:!bg-[#8a171b] !border-none rounded-lg shadow-md transition-all flex items-center justify-center'>
                Reset Password
              </Button>
            </div>

            <div className="flex items-center my-6">
              <div className="flex-grow border-t border-gray-200"></div>
              <span className="flex-shrink-0 mx-4 text-gray-400 text-[13px]">Remembered your password?</span>
              <div className="flex-grow border-t border-gray-200"></div>
            </div>

            <Button 
              size='large' 
              onClick={() => navigate("/login")} 
              className='w-full h-12 text-base font-medium !text-[#A91D22] border !border-[#A91D22] !bg-[#fdf2f2] hover:!bg-[#fce4e4] rounded-lg transition-all flex items-center justify-center gap-2'
            >
              Back to Sign in
            </Button>
          </div>
        </div>

        <span className='text-gray-400 text-xs md:text-sm select-none pb-6 mt-auto'>&copy; 2026 Vantage AI. All rights reserved.</span>
      </div>

      {/* Right side: Image Panel */}
      <div className='hidden lg:flex w-1/2 relative bg-black items-center justify-center overflow-hidden'>
        <img src={loginBackground} alt="Vantage AI Dashboard Graphic" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        
        <div className="absolute top-16 left-16 z-10">
          <div className="text-white text-[42px] leading-[1.2] font-bold tracking-tight">
            <div>Turn raw data into</div>
            <div>professional <span className="text-[#FCA5A5]">Dashboards</span></div>
            <div>in minutes.</div>
          </div>
        </div>

        {/* Valiantlytix Logo Overlay */}
        <div className="absolute bottom-12 right-12 z-10">
          <img src={valiantlytixLogo} alt="Valiantlytix Logo" className="w-[180px] h-auto object-contain" />
        </div>
      </div>

      {/* Error Modal */}
      <AuthErrorModal
        open={!!errorMessage}
        onClose={() => setErrorMessage(null)}
        title={errorTitle}
        message={errorMessage || ""}
      />
    </div>
  )
}

export default ResetPasswordPage